import { defaultRoutes, asyncRoutes, CustomRouteConfig } from "@/router/conifg"
// import { PROPERTY_GROUP } from "@/types/base"
import { ActionContext } from "vuex"
import { State as UserState } from "./user"
import store from ".."

function hasPermission(
    permissionList: string[],
    obj: string[],
    route: string,
    pages: { [key: number]: string }
) {
    // todo
    return store.state.user.roles.includes("admin") ? true : route !== "/channel/manage" // 渠道管理特判

    if (obj) {
        const apiList = []
        for (const key in obj) {
            apiList.push(obj[key])
        }
        for (let i = 0; i < permissionList.length; i++) {
            if (
                apiList.includes(permissionList[i]) &&
                Object.keys(pages).filter(key => pages[Number(key)] === route).length
            ) {
                return true
            }
        }
    }
}

// 过滤掉没有权限的路由
export function filterAsyncRoutes(user: UserState) {
    const { permissions, pages } = user
    const res: CustomRouteConfig[] = []
    asyncRoutes.forEach(route => {
        const temp = { ...route }
        if (temp.children) {
            temp.children = temp.children.filter(v =>
                hasPermission(permissions, v.meta.api, `${route.path}/${v.path}`, pages)
            )
        }
        const isEmptyMenu = temp.children && temp.children.length === 0
        if (!isEmptyMenu) res.push(temp)
    })
    return res
}
export interface State {
    routes: any[]
    addRoutes: any[]
}

const state: State = {
    routes: [],
    addRoutes: []
}

const mutations = {
    setRouters: (state: State, routes: any) => {
        state.addRoutes = routes
        state.routes = defaultRoutes.concat(routes)
    }
}

const actions = {
    getAsyncPermissionRoutes(context: ActionContext<State, any>, user: UserState) {
        const lastRoutes = filterAsyncRoutes(user)
        context.commit("setRouters", lastRoutes)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
